import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useTheme } from '../../../context/ThemeContext';

/**
 * Higher-order component that wraps a component with styled-components ThemeProvider
 * Uses the app's Redux-based theme state from ThemeContext
 */
export const withThemeProvider = <P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  const WrappedComponent: React.FC<P> = (props) => {
    const { theme } = useTheme();
    const isDarkMode = theme === 'dark';

    return (
      <ThemeProvider theme={{ mode: isDarkMode ? 'dark' : 'light' }}>
        <Component {...props} />
      </ThemeProvider>
    );
  };

  WrappedComponent.displayName = `withThemeProvider(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};
